import React from 'react';
import { PropTypes } from 'prop-types';
import { TextField } from '../../TextField';
import { Button } from '../../Button';

import styles from './ImageCardSubContent.js.module.scss';

export const ImageCardSubContent = (props) => {
  const {
    className = '',
    textFields,
    close,
    save,
    disabled,
  } = props;

  return (
    <div className={`${styles.container} ${className}`}>
      {textFields.map(textField => (
        <TextField
          key={textField.label}
          className="mb-3"
          label={textField.label}
          placeholder={textField.placeholder}
          value={textField.value}
          onChange={textField.onChange}
        />
      ))}
      <div className="d-flex justify-content-end">
        <Button
          onClick={close}
          className="btn-square _md _cornflower-blue mr-2"
        >
          Cancel
        </Button>
        <Button
          className="btn-square _md _filled _cornflower-blue"
          onClick={save}
          disabled={disabled}
        >
          Save Changes
        </Button>
      </div>
    </div>
  );
}

ImageCardSubContent.propTypes = {
  className: PropTypes.string,
  textFields: PropTypes.array,
  close: PropTypes.func,
  save: PropTypes.func,
  disabled: PropTypes.bool,
};

